// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { Lookup } from './lookup';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class SearchOrder extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  searchOrderId!: number;
  adminId?: number;
  companyIdentifier?: string;
  createdBy?: string;
  createdDate!: Date;
  flags?: number;
  jsonOrder?: string;
  jsonVersion?: string;
  orderDate?: Date;
  orderTotal!: number;
  providerSearchOrderIdentifier?: string;
  reference?: string;
  searchEntityName?: string;
  searchProviderLookupId!: number;
  searchStatusLookupId!: number;
  searchTypeLookupId!: number;
  ts!: string;
  updatedBy?: string;
  updatedDate!: Date;
  searchProviderLookup!: Lookup;
  searchStatusLookup!: Lookup;
  searchTypeLookup!: Lookup;
}

